// import santaHat from "../../assets/images/santa-hat.webp";
import { _sizeText, _typeLogo } from "../../core/core";
import { Text } from "../texts/text";
import "./Logo.css";

export const Logo = ({ type = _typeLogo.default, link = "/", ...props }) => {
  const now = new Date();
  // const isSantaHat =
  //   now.getMonth() === 11 || (now.getMonth() === 0 && now.getDate() <= 31);

  return (
    <>
      <a href={link} className="logo">
        <div className={`work-body work-body-${type}`}>
          <Text size={_sizeText.mbold}>VIWORK</Text>
        </div>
        {/* {isSantaHat && (
          <div className="santa-hat">
            <img src={santaHat} />
          </div>
        )} */}
      </a>
    </>
  );
};
